import {
  useEffect,
  useState,
  useRef
} from 'react'
import {
  Box,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
  useOutsideClick
} from '@chakra-ui/react'
import { ImagesPng } from 'assets/images'
import {
  isMobile,
  howManyDayAgo
} from 'utils/helpers'
import { COLORS } from 'utils/styles'

export const ContentModal = ({
  item,
  isOpen,
  onClose,
  title,
  isNotifModalOpen
}) => {
  const [description, setDescription] = useState('')
  const [isLandscape, setIsLandscape] = useState(false)
  const [vh, setVh] = useState(window.innerHeight)
  const link = item?.link
  const modalRef = useRef()

  const setupDescription = () => {
    if (item?.link === null) {
      setDescription(item?.description ?? '-')
    } else {
      setDescription(
        <>
          {item?.description}
          <b />
          {
            title === 'connector'
            || (title === 'proximity' && item?.link && !item?.link_title)
            || !item?.link_title
              ? null
              : (
                <Stack m={5}>
                  <Box
                    type="button"
                    name="open-link"
                    onClick={() => window.open(item?.link, '_blank')}
                    background={COLORS.gold}
                    padding="4px 12px"
                    borderRadius="5px"
                    left="50%"
                    textAlign="center"
                    cursor="pointer"
                  >
                    {item?.link_title}
                  </Box>
                </Stack>
              )
          }
        </>
      )
    }
  }

  useEffect(() => {
    const update = () => {
      const height = window.visualViewport?.height || window.innerHeight
      setVh(height)
    }

    update()

    window.visualViewport?.addEventListener('resize', update)
    window.addEventListener('resize', update)

    return () => {
      window.visualViewport?.removeEventListener('resize', update)
      window.removeEventListener('resize', update)
    }
  }, [])

  useEffect(() => {
    if (isOpen) {
      localStorage.setItem('is-notif-modal-open', 'false')
      sessionStorage.removeItem('id')
    }
  }, [isOpen])

  useEffect(() => {
    setupDescription()
  }, [item])

  useOutsideClick({
    ref: modalRef,
    handler: () => {
      if (isNotifModalOpen === true) {
        onClose()
      }
    }
  })

  useEffect(() => {
    const onResize = () => {
      const landscape = window.matchMedia('(orientation: landscape)').matches
      setIsLandscape(landscape)
    }

    window.addEventListener('resize', onResize)
    onResize()

    return () => window.removeEventListener('resize', onResize)
  }, [])

  return (
    <Modal
      isCentered
      isOpen={isOpen}
      onClose={() => {
        setDescription('')
        onClose()
      }}
    >
      <ModalOverlay />

      <ModalContent
        ref={modalRef}
        className={title === 'connector' ? 'connector-modal' : 'notif-modal'}
        sx={{
          '&.connector-modal': {
            maxWidth: '650px !important',
            '@media (max-width: 600px)': {
              maxWidth: '450px'
            }
          }
        }}
      >
        <ModalHeader>
          <Stack direction="row">
            <Image
              boxSize="60px"
              objectFit="cover"
              src={item?.image || ImagesPng.DefaultImage}
              alt={item?.title}
              borderRadius="full"
            />

            <Stack>
              <Text
                fontWeight={600}
                data-name="notificationModalTitle"
              >
                {item?.title}
              </Text>

              <Text
                fontSize="12px"
                color={COLORS.gray}
              >
                {howManyDayAgo(item?.data)}
              </Text>
            </Stack>
          </Stack>
        </ModalHeader>

        <ModalCloseButton />

        <ModalBody>
          {
            title === 'connector'
            || (
              title === 'proximity'
              && item?.link
              && !item?.link_title
            )
              ? (
                <Box
                  position={isLandscape && isMobile() ? 'fixed' : 'relative'}
                  top="0"
                  left="0"
                  width={isLandscape && isMobile() ? '100vw' : '100%'}
                  height={isLandscape && isMobile() ? `${vh}px` : '315px'}
                  zIndex={isLandscape && isMobile() ? 9999 : 'auto'}
                  bg="black"
                >
                  <iframe
                    id="odysee-iframe"
                    title="videoNotification"
                    width="100%"
                    height="100%"
                    src={link}
                    allowFullScreen
                  />
                </Box>
              ) : null
          }

          {description}
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}
